import { FileInfo } from '@/Domain/ReviewedDocumentation/FileInfo'

export class FileInfoDTO {
  private _documentId: number
  private _fileName: string
  private _rejectionReason: string
  private _fileType: string
  private _fileStatus: string

  public static fromFileInfo (fileInfo: FileInfo): FileInfoDTO {
    return new FileInfoDTO(
      fileInfo.documentId(),
      fileInfo.fileName(),
      fileInfo.reasonRejection(),
      fileInfo.fileStatus(),
      fileInfo.fileType()
    )
  }

  constructor (
    documentId: number,
    fileName: string,
    rejectionReason: string,
    fileStatus: string,
    fileType: string
  ) {
    this._documentId = documentId
    this._fileName = fileName
    this._rejectionReason = rejectionReason
    this._fileType = fileType
    this._fileStatus = fileStatus
  }

  get documentId (): number {
    return this._documentId
  }

  get fileName (): string {
    return this._fileName
  }

  get rejectionReason (): string {
    return this._rejectionReason
  }

  get fileType (): string {
    return this._fileType
  }

  get fileStatus (): string {
    return this._fileStatus
  }
}
